import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { columns: "2" }
const _hoisted_2 = ["value", "disabled", "onTextInputChange"]
const _hoisted_3 = { style: {"display":"flex","align-items":"flex-end","gap":"16px"} }
const _hoisted_4 = ["value", "disabled", "onDropdownChange"]
const _hoisted_5 = ["value", "disabled", "onDropdownChange"]
const _hoisted_6 = ["disabled", "onButtonClick"]
const _hoisted_7 = {
  key: 0,
  columns: "3"
}
const _hoisted_8 = ["value", "disabled", "onTextInputChange"]
const _hoisted_9 = ["value", "disabled", "onTextInputChange"]
const _hoisted_10 = ["value", "min", "max", "disabled", "onTextInputChange"]
const _hoisted_11 = {
  key: 1,
  columns: "2"
}
const _hoisted_12 = { style: {"display":"flex","flex-direction":"column","gap":"8px","width":"100%"} }
const _hoisted_13 = ["value", "disabled", "onTextInputChange"]
const _hoisted_14 = ["disabled", "onButtonClick"]
const _hoisted_15 = ["disabled", "onButtonClick"]
const _hoisted_16 = {
  key: 0,
  style: {"display":"flex","align-items":"flex-start"}
}
const _hoisted_17 = ["value", "disabled", "options", "onDropdownChange"]
const _hoisted_18 = ["value", "disabled", "onTextInputChange"]
const _hoisted_19 = ["disabled"]

import { computed } from 'vue';

export interface ConfigSetting {
  name: string;
  type: 'string' | 'number' | 'integer' | 'bool';
  enum?: string[];
  minimum?: string;
  maximum?: string;
  value?: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChartSettings',
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    allowDefaults: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const settings = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

function updateSetting(index: number, patch: Partial<ConfigSetting>) {
  const next = [...settings.value];
  next[index] = {
    ...next[index],
    ...patch,
  };

  settings.value = next;
}

function removeSetting(index: number) {
  const next = [...settings.value];
  next.splice(index, 1);
  settings.value = next;
}

function addSetting() {
  settings.value = [
    ...settings.value,
    {
      name: '',
      type: 'string',
      enum: [],
    },
  ];
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[12] || (_cache[12] = _createElementVNode("trailhand-form-row", null, [
      _createElementVNode("h3", null, "Settings")
    ], -1)),
    _cache[13] || (_cache[13] = _createTextVNode()),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(settings.value, (setting, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        _createElementVNode("trailhand-form-row", _hoisted_1, [
          _createElementVNode("trailhand-text-input", {
            value: setting.name,
            label: "Setting Name",
            disabled: _ctx.disabled,
            required: "",
            onTextInputChange: 
          (e) => updateSetting(index, { name: e.detail.value })
        
          }, null, 40, _hoisted_2),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("trailhand-dropdown", {
              value: setting.type,
              label: "Setting Type",
              disabled: _ctx.disabled,
              required: "",
              style: {"flex":"1"},
              options: [
            { label: 'String', value: 'string' },
            { label: 'Number', value: 'number' },
            { label: 'Integer', value: 'integer' },
            { label: 'Boolean', value: 'bool' }
          ],
              onDropdownChange: 
            (e) => {
              const value = e.detail.value;

              updateSetting(index, {
                type: value,
                enum:
                  value === 'string'
                    ? (setting.enum ?? [])
                    : undefined,
                minimum:
                  value === 'number' || value === 'integer'
                    ? setting.minimum
                    : undefined,
                maximum:
                  value === 'number' || value === 'integer'
                    ? setting.maximum
                    : undefined,
                value: undefined,
              });
            }
          
            }, null, 40, _hoisted_4),
            _cache[0] || (_cache[0] = _createTextVNode()),
            (setting.type === 'bool' && props.allowDefaults)
              ? (_openBlock(), _createElementBlock("trailhand-dropdown", {
                  key: 0,
                  value: setting.value,
                  label: "Default Value",
                  disabled: _ctx.disabled,
                  style: {"flex":"1"},
                  options: [
            { label: 'True', value: true },
            { label: 'False', value: false }
          ],
                  onDropdownChange: 
            (e) => updateSetting(index, { value: e.detail.value })
          
                }, null, 40, _hoisted_5))
              : _createCommentVNode("", true),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createElementVNode("trailhand-button", {
              variant: "destructive",
              disabled: _ctx.disabled,
              onButtonClick: ($event: any) => (removeSetting(index))
            }, "\n          Remove\n        ", 40, _hoisted_6)
          ])
        ]),
        _cache[8] || (_cache[8] = _createTextVNode()),
        (setting.type === 'number' || setting.type === 'integer')
          ? (_openBlock(), _createElementBlock("trailhand-form-row", _hoisted_7, [
              _createElementVNode("trailhand-text-input", {
                value: setting.minimum,
                label: "Minimum",
                type: "number",
                disabled: _ctx.disabled,
                onTextInputChange: 
          (e) => updateSetting(index, { minimum: e.detail.value })
        
              }, null, 40, _hoisted_8),
              _cache[3] || (_cache[3] = _createTextVNode()),
              _createElementVNode("trailhand-text-input", {
                value: setting.maximum,
                label: "Maximum",
                type: "number",
                disabled: _ctx.disabled,
                onTextInputChange: 
          (e) => updateSetting(index, { maximum: e.detail.value })
        
              }, null, 40, _hoisted_9),
              _cache[4] || (_cache[4] = _createTextVNode()),
              (props.allowDefaults)
                ? (_openBlock(), _createElementBlock("trailhand-text-input", {
                    key: 0,
                    value: setting.value,
                    label: "Default Value",
                    type: "number",
                    min: setting.minimum,
                    max: setting.maximum,
                    disabled: _ctx.disabled,
                    onTextInputChange: 
          (e) => updateSetting(index, { value: e.detail.value })
        
                  }, null, 40, _hoisted_10))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _cache[9] || (_cache[9] = _createTextVNode()),
        (setting.type === 'string')
          ? (_openBlock(), _createElementBlock("trailhand-form-row", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setting.enum || [], (value, enumIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: enumIndex,
                    style: {"display":"flex","align-items":"flex-end","gap":"8px"}
                  }, [
                    _createElementVNode("trailhand-text-input", {
                      value: value,
                      label: "Allowed Value",
                      disabled: _ctx.disabled,
                      style: {"flex":"1"},
                      onTextInputChange: 
              (e) => {
                const next = [...(setting.enum || [])];
                next[enumIndex] = e.detail.value;
                updateSetting(index, { enum: next });
              }
            
                    }, null, 40, _hoisted_13),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _createElementVNode("trailhand-button", {
                      variant: "destructive",
                      disabled: _ctx.disabled,
                      onButtonClick: 
              () => {
                const next = [...(setting.enum || [])];
                next.splice(enumIndex, 1);
                updateSetting(index, { 
                  enum: next,
                  value: (!next || next.length === 0)
                    ? ''
                    : setting.value, 
                });
              }
            
                    }, "\n            Remove Value\n          ", 40, _hoisted_14)
                  ]))
                }), 128)),
                _cache[6] || (_cache[6] = _createTextVNode()),
                _createElementVNode("div", null, [
                  _createElementVNode("trailhand-button", {
                    variant: "alternate",
                    disabled: _ctx.disabled,
                    onButtonClick: 
              () => {
                updateSetting(index, {
                  enum: [...(setting.enum || []), ''],
                  value: (!setting.enum || setting.enum.length === 0)
                    ? ''
                    : setting.value,
                })

              }
            
                  }, "\n            Add Value\n          ", 40, _hoisted_15)
                ])
              ]),
              _cache[7] || (_cache[7] = _createTextVNode()),
              (props.allowDefaults)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (setting.enum && setting.enum.length > 0)
                      ? (_openBlock(), _createElementBlock("trailhand-dropdown", {
                          key: 0,
                          value: setting.value,
                          label: "Default Value",
                          disabled: 
            _ctx.disabled ||
            !(setting.enum && setting.enum.some((v) => v))
          ,
                          style: {"flex":"1"},
                          options: 
            (setting.enum || [])
              .filter((v) => v)
              .map((v) => ({
                label: v,
                value: v,
              }))
          ,
                          onDropdownChange: 
            (e) => updateSetting(index, { value: e.detail.value })
          
                        }, null, 40, _hoisted_17))
                      : (_openBlock(), _createElementBlock("trailhand-text-input", {
                          key: 1,
                          value: setting.value,
                          label: "Default Value",
                          disabled: _ctx.disabled,
                          style: {"flex":"1"},
                          onTextInputChange: 
            (e) => updateSetting(index, { value: e.detail.value })
          
                        }, null, 40, _hoisted_18))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _cache[10] || (_cache[10] = _createTextVNode()),
        _cache[11] || (_cache[11] = _createElementVNode("div", { style: {"width":"100%","border-bottom":"1px solid var(--th-color-border)"} }, null, -1))
      ], 64))
    }), 128)),
    _cache[14] || (_cache[14] = _createTextVNode()),
    _createElementVNode("div", null, [
      _createElementVNode("trailhand-button", {
        variant: "alternate",
        disabled: _ctx.disabled,
        onButtonClick: addSetting
      }, "\n      Add Setting\n    ", 40, _hoisted_19)
    ])
  ], 64))
}
}

})